import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=5e6792a7&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"
import style0 from "./Answer.vue?vue&type=style&index=0&id=5e6792a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6792a7",
  null
  
)

export default component.exports